

(function blocAvantagesChiffres () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "bloc-avantages-chiffres";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
    })

    })()